
export default {
    contato: state => state.contato,
    contatos: state => state.contatos.map(p => ({
        ...p,
        selected: state.selecionados.includes(p.id)
    })),
    selecionados: state => state.selecionados
}